package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.operation.get_cash_register_config


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PriceLevelForm(
    @SerialName("priceLevel")
    val priceLevel: PriceLevel?,
    @SerialName("timeInterval")
    val timeInterval: TimeInterval?,
    @SerialName("__typename")
    val typename: String?,
    @SerialName("weekDays")
    val weekDays: Int?
)